<template>
  <community-member :user="source" :class="index%2===0 ? 'even' : 'odd'" />
</template>

<script>
import CommunityMember from './CommunityMember'

export default {
  name: 'CommunityMemberVirtualItem',
  components: { CommunityMember },
  // https://github.com/tangbc/vue-virtual-scroll-list#simple-usage
  props: {
    index: {
      type: Number,
      default: 0
    },
    source: {
      type: Object,
      default: () => {
      }
    }
  }
}
</script>

<style scoped lang="scss">
.even {
  background: #FFF
}

.odd {
  background: #F8F8F8;
}

</style>
